// extracted by mini-css-extract-plugin
export default {"component":"HomepageFAQ__component-_kDi"};